<template>
  <div>
    <div v-for="item in sortItems" :key="item.uuid">
      <v-row>
        <v-col cols="2" align-self="center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                  v-on="on"
                  tile
                  color="error"
                  icon
                  large
                  @click="removeSort(item.uuid)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("Remove") }}</span>
          </v-tooltip>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-autocomplete
              v-model="item.fieldTitle"
              v-bind:label="$t('Field')"
              :items="getFieldTitles()"
          ></v-autocomplete>
        </v-col>

        <v-col cols="4">
          <v-radio-group v-model="item.sortOrder" row>
            <v-radio value="asc">
              <template v-slot:label>
                <div>
                  <v-icon>mdi-sort-alphabetical-ascending</v-icon>
                </div>
              </template>
            </v-radio>
            <v-radio value="desc">
              <template v-slot:label>
                <div>
                  <v-icon>mdi-sort-alphabetical-descending</v-icon>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>

        <!-- <v-col cols="1" align-self="center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" tile large color="blue darken-4" icon @click="addSort()">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Add')}}</span>
          </v-tooltip>
        </v-col> -->
      </v-row>
      <!-- <v-subheader v-if="!isLastSort(item.uuid)">---THEN BY---</v-subheader> -->
    </div>
  </div>
</template>
<script>
import SortItem from "@/ecm/models/search/SortItem";
export default {
  name: "SortModal",
  props: {
    fieldList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    fieldList: function (newVal, oldVal) {
      this.setSortObj(this.sortStr);
    },
  },
  created() {
    this.addSort();
  },
  data() {
    return {
      modal: {
        title: this.$t("Sort"),
        key: "sortModal"
      },
      open: false,
      sortItems: [],
      sortStr: ""
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    }
  },
  methods: {
    getSortStr(){
      let sort = "";
      //Validates if the sort configuration is not empty
      if(this.sortItems.length == 0 || (this.sortItems.length == 1 && this.getFieldCode(this.sortItems[0].fieldTitle) == "")){
        return null;
      }
      else
      {
        this.sortItems.forEach(item => {
          sort += "FIELD:" + this.getFieldCode(item.fieldTitle)
          sort += "ORDER:" + item.sortOrder
          sort += ";"
        });
        return sort;
      }
      
    },
    getFieldCode(fieldTitle){
      let fieldCode = "";
      this.fieldList.forEach(field => {
        if(field.Title == fieldTitle){
          fieldCode = field.Code;
        } 
      });
      return fieldCode;
    },
    getFieldTitle(fieldCode){
      let fieldTitle = "";
      this.fieldList.forEach(field => {
        if(field.Code == fieldCode){
          fieldTitle = field.Title;
        } 
      });
      return fieldTitle;
    },
    load(sortItems){
      this.sortItems = sortItems;
    },
    reset(){
      this.setSortObj("");
    },
    setSortObj(sortStr){
      if(sortStr != ""){
        this.sortStr = sortStr;
      }
      else
      {
        this.sortStr = "";
      }
      let sortItems = sortStr.split(';');
      this.sortItems = [];
      sortItems.forEach(item => {
        let sortItem = new SortItem();
        const match = item.match(/FIELD:(.*?)ORDER:(.*)/);
        if(match){
          sortItem.fieldTitle = this.getFieldTitle(match[1]);
          sortItem.sortOrder = match[2];
          this.sortItems.push(sortItem);
        }
      });
      if(this.sortItems.length === 0){
        this.addSort();
      }
    },
    getFieldTitles() {
      if (this.fieldList || this.fieldList.length > 0) {
        return Array.from(new Set(this.fieldList.map(f => f.Title)));
      } else {
        return [];
      }
    },
    addSort() {
      this.sortItems.push(new SortItem());
    },
    removeSort(uuid) {
      this.sortItems = this.sortItems.filter(item => item.uuid !== uuid);
      if (this.sortItems.length == 0) {
        this.addSort();
      }
    },
    onSorted() {
      if (this.sortItems.length == 1 && this.sortItems[0].fieldTitle == "")
        this.$emit("on-sorted", []);
      else this.$emit("on-sorted", this.sortItems);
    },
    isLastSort(uuid) {
      if (this.sortItems.length <= 1) return true;
      return this.sortItems[this.sortItems.length - 1].uuid == uuid;
    }
  }
};
</script>
